import type { NotificationHubItem } from "./mapApiNotificationToHubItem.ts";
import type { HubCategory } from "./notificationTypes.ts";

export type HubFilterTab = "all" | "unread" | HubCategory;

const HUB_TAB_DEFINITIONS: { id: HubFilterTab; label: string }[] = [
  { id: "all", label: "Todas" },
  { id: "unread", label: "No leídas" },
  { id: "projects", label: "Obras" },
  { id: "materials", label: "Materiales" },
  { id: "account", label: "Cuenta" },
  { id: "social", label: "Social" },
  { id: "work", label: "Trabajo" },
  { id: "portfolio", label: "Portfolio" },
  { id: "system", label: "Sistema" },
];

export function hubTabsForItems(
  hasAccount: boolean,
  hasSystem: boolean
): { id: HubFilterTab; label: string }[] {
  let tabs = HUB_TAB_DEFINITIONS;
  if (!hasAccount) tabs = tabs.filter((t) => t.id !== "account");
  if (!hasSystem) tabs = tabs.filter((t) => t.id !== "system");
  return tabs;
}

export function countsByHubTab(
  items: Pick<NotificationHubItem, "read" | "category">[]
): Record<HubFilterTab, number> {
  const unread = items.filter((i) => !i.read).length;
  const byCategory = (c: HubCategory) =>
    items.filter((i) => i.category === c).length;
  return {
    all: items.length,
    unread,
    projects: byCategory("projects"),
    materials: byCategory("materials"),
    account: byCategory("account"),
    social: byCategory("social"),
    work: byCategory("work"),
    portfolio: byCategory("portfolio"),
    system: byCategory("system"),
  };
}

export function filterHubItemsByTab(
  items: NotificationHubItem[],
  tab: HubFilterTab
): NotificationHubItem[] {
  if (tab === "unread") return items.filter((i) => !i.read);
  if (tab === "all") return items.slice();
  return items.filter((i) => i.category === tab);
}
